import { API_BASE } from '@/shared/services/api';
import { useTranslation } from "react-i18next";import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/shared/components/ui/card';
import { Badge } from '@/shared/components/ui/badge';
import { Button } from '@/shared/components/ui/button';
import { ExternalLink, Loader2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { getStatusColor } from '@/shared/utils';

const API_URL = API_BASE;

export const RecentShipments = () => {const { t } = useTranslation("ezparcel");
  const [recentShipments, setRecentShipments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRecentShipments = async () => {
      try {
        const token = localStorage.getItem('ezerpToken');
        const response = await fetch(`${API_URL}/api/ezparcel/recent-shipments?limit=5`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (response.ok) {
          const data = await response.json();
          setRecentShipments(data.map((s) => ({
            id: s.id || s.shipment_id,
            trackingId: s.tracking_number || s.id,
            status: s.status?.toLowerCase() || 'pending',
            customer: s.recipient_name || 'N/A',
            parcels: s.parcels || 1,
            driverName: s.driver_name || 'Unassigned'
          })));
        }
      } catch (err) {
        console.error('Failed to fetch recent shipments:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchRecentShipments();
  }, []);

  const getStatusLabel = (status) => {
    return (status || '').replace('_', ' ').toUpperCase();
  };

  if (loading) {
    return (
      <Card className="card-elevated">
        <CardHeader>
          <CardTitle className="text-lg font-semibold">{t("recentShipments", "Recent Shipments")}</CardTitle>
        </CardHeader>
        <CardContent className="flex justify-center py-8">
          <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
        </CardContent>
      </Card>);

  }

  return (
    <Card className="card-elevated">
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle className="text-lg font-semibold">{t("recentShipments", "Recent Shipments")}</CardTitle>
        <Link to="/shipments">
          <Button variant="ghost" size="sm">{t("viewAll", "View all")}

            <ExternalLink className="ml-2 h-4 w-4" />
          </Button>
        </Link>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {recentShipments.length === 0 ?
          <p className="text-center text-muted-foreground py-4">{t("noRecentShipments", "No recent shipments")}</p> :
          recentShipments.map((shipment) =>
          <Link
            key={shipment.id}
            to={`/shipments/${shipment.id}`}
            className="block">
              <div className="flex items-center justify-between p-3 rounded-lg border border-border hover:bg-muted/50 transition-colors">
                <div className="flex-1">
                  <div className="flex items-center gap-3">
                    <p className="font-mono text-sm font-medium">{shipment.trackingId}</p>
                    <Badge className={getStatusColor(shipment.status)}>
                      {getStatusLabel(shipment.status)}
                    </Badge>
                  </div>
                  <p className="text-sm text-muted-foreground mt-1">{shipment.customer}</p>
                </div>
                <div className="text-right">
                  <p className="text-sm font-medium">{shipment.parcels}{t("parcels", "parcels")}</p>
                  <p className="text-xs text-muted-foreground">{shipment.driverName}</p>
                </div>
              </div>
            </Link>
          )}
        </div>
      </CardContent>
    </Card>);

};